import { render } from "./index.vue?vue&type=template&id=78d22a9d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/captcha/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78d22a9d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78d22a9d', __exports__)) {
    api.reload('78d22a9d', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=78d22a9d", () => {
    api.rerender('78d22a9d', render)
  })

}


export default __exports__